import { Dialog } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledDialog = styled(Dialog)({
    '& .MuiDialog-container .MuiPaper-root.MuiDialog-paper': {
        maxWidth: '660px',
        maxHeight: '97vh',
        margin: '1.125vh auto'
    }
});

export default StyledDialog;